var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagetocaptionai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3146.285127678686,
    height: 636.3403054022842,
    viewBox: "0 0 3146.285127678686 636.3403054022842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(7.314256383934301) translate(10, 10)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs8569"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG8570",
    featureKey: "symbolContainer",
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#35d0ba"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 67,
    rx: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG8571",
    featureKey: "symbolFeature-0",
    transform: "matrix(1.151315789473684,0,0,1.151315789473684,20,15)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -247.333,
    y: -144.651,
    display: "inline",
    fill: "#ffffff",
    width: 473.333,
    height: 236
  })), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    fill: "#ffffff",
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,2v28H2V2H30 M32,0H0v32h32V0L32,0z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 24.593,
    x2: 23.875,
    y2: 24.593
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 18.864,
    x2: 23.875,
    y2: 18.864
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 13.136,
    x2: 23.875,
    y2: 13.136
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 7.407,
    x2: 23.875,
    y2: 7.407
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M31,1v30H1V1H31 M32,0H0v32h32V0L32,0z"
  })), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 24.593,
    x2: 23.875,
    y2: 24.593
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 18.864,
    x2: 23.875,
    y2: 18.864
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 13.136,
    x2: 23.875,
    y2: 13.136
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 7.407,
    x2: 23.875,
    y2: 7.407
  })), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M30,2v28H2V2H30 M32,0H0v32h32V0L32,0z"
  })), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 24.593,
    x2: 23.875,
    y2: 24.593
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 18.864,
    x2: 23.875,
    y2: 18.864
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 13.136,
    x2: 23.875,
    y2: 13.136
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 7.407,
    x2: 23.875,
    y2: 7.407
  })), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,32h32V0H0V32z M0.5,0.5h31v31h-31V0.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.125,
    y: 24.343,
    width: 15.75,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.125,
    y: 18.614,
    width: 15.75,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.125,
    y: 12.886,
    width: 15.75,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.125,
    y: 7.157,
    width: 15.75,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    fill: "#ffffff",
    width: 31,
    height: 31
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M31,1v30H1V1H31 M32,0H0v32h32V0L32,0z"
  })), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 24.593,
    x2: 23.875,
    y2: 24.593
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 18.864,
    x2: 23.875,
    y2: 18.864
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 13.136,
    x2: 23.875,
    y2: 13.136
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    x1: 8.125,
    y1: 7.407,
    x2: 23.875,
    y2: 7.407
  })), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    d: "M0,32h32V0H0V32z M2,2h28v28H2V2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.125,
    y: 23.593,
    display: "inline",
    width: 15.75,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.125,
    y: 17.864,
    display: "inline",
    width: 15.75,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.125,
    y: 12.136,
    display: "inline",
    width: 15.75,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.125,
    y: 6.407,
    display: "inline",
    width: 15.75,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    fill: "#ffffff",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M7,25h18V7H7V25z M8.125,8.125h15.75v15.75H8.125V8.125z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.57,
    y: 20.271,
    fill: "#ffffff",
    width: 8.859,
    height: 1.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.57,
    y: 17.049,
    fill: "#ffffff",
    width: 8.859,
    height: 1.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.57,
    y: 13.826,
    fill: "#ffffff",
    width: 8.859,
    height: 1.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.57,
    y: 10.604,
    fill: "#ffffff",
    width: 8.859,
    height: 1.125
  })))), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG8572",
    featureKey: "nameFeature-0",
    transform: "matrix(0.8734739419747969,0,0,0.8734739419747969,94.41451709843422,8.531542335711656)",
    fill: "#111111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.96 13.440000000000001 l0 -0.24 c0 -1.44 1.2 -2.36 2.76 -2.36 s2.76 0.92 2.76 2.36 l0 0.24 c0 1.44 -1.2 2.4 -2.76 2.4 s-2.76 -0.96 -2.76 -2.4 z M3.32 37.8 l0 -16.72 c0 -1.36 1.04 -2.44 2.4 -2.44 s2.44 1.08 2.44 2.44 l0 16.72 c0 1.36 -1.08 2.4 -2.44 2.4 c-1.32 0 -2.4 -1.04 -2.4 -2.4 z M14.48 37.8 l0 -16.72 c0 -1.36 1.04 -2.44 2.4 -2.44 s2.44 1.08 2.44 2.44 l0 1 c1.36 -1.88 3.2 -3.64 6.44 -3.64 c3.04 0 5.2 1.48 6.32 3.72 c1.68 -2.24 3.92 -3.72 7.12 -3.72 c4.6 0 7.4 2.92 7.4 8.08 l0 11.28 c0 1.36 -1.04 2.4 -2.4 2.4 s-2.44 -1.04 -2.44 -2.4 l0 -9.8 c0 -3.36 -1.56 -5.16 -4.28 -5.16 c-2.64 0 -4.52 1.84 -4.52 5.24 l0 9.72 c0 1.36 -1.08 2.4 -2.4 2.4 c-1.36 0 -2.44 -1.04 -2.44 -2.4 l0 -9.84 c0 -3.28 -1.6 -5.12 -4.28 -5.12 s-4.52 2 -4.52 5.24 l0 9.72 c0 1.36 -1.08 2.4 -2.44 2.4 c-1.32 0 -2.4 -1.04 -2.4 -2.4 z M58.559999999999995 40.44 c-3.96 0 -7.48 -2.28 -7.48 -6.52 l0 -0.08 c0 -4.56 3.56 -6.8 8.72 -6.8 c2.36 0 4.04 0.36 5.68 0.88 l0 -0.52 c0 -3 -1.84 -4.6 -5.24 -4.6 c-1.84 0 -3.36 0.32 -4.68 0.84 c-0.28 0.08 -0.52 0.12 -0.76 0.12 c-1.12 0 -2.04 -0.88 -2.04 -2 c0 -0.88 0.6 -1.64 1.32 -1.92 c2 -0.76 4.04 -1.24 6.8 -1.24 c3.16 0 5.52 0.84 7 2.36 c1.56 1.52 2.28 3.76 2.28 6.52 l0 10.4 c0 1.32 -1.04 2.32 -2.36 2.32 c-1.4 0 -2.36 -0.96 -2.36 -2.04 l0 -0.8 c-1.44 1.72 -3.64 3.08 -6.88 3.08 z M59.92 36.92 c3.2 0 5.64 -1.84 5.64 -4.52 l0 -1.44 c-1.24 -0.48 -2.88 -0.84 -4.8 -0.84 c-3.12 0 -4.96 1.32 -4.96 3.52 l0 0.08 c0 2.04 1.8 3.2 4.12 3.2 z M85.36 46.480000000000004 c-2.96 0 -5.6 -0.64 -8.16 -1.88 c-0.84 -0.32 -1.36 -1 -1.36 -1.92 c0 -1.08 0.92 -2 2.04 -2 c0.36 0 0.64 0.08 0.88 0.2 c1.92 1.08 4.04 1.68 6.48 1.68 c4.32 0 6.68 -2.24 6.68 -6.48 l0 -1.64 c-1.76 2.28 -3.96 3.88 -7.44 3.88 c-4.96 0 -9.6 -3.68 -9.6 -9.88 l0 -0.08 c0 -6.24 4.68 -9.92 9.6 -9.92 c3.56 0 5.76 1.64 7.4 3.6 l0 -1 c0 -1.32 1.08 -2.4 2.4 -2.4 c1.36 0 2.44 1.08 2.44 2.44 l0 14.6 c0 3.56 -0.92 6.2 -2.68 7.96 c-1.92 1.92 -4.88 2.84 -8.68 2.84 z M85.76 34.2 c3.36 0 6.2 -2.36 6.2 -5.8 l0 -0.08 c0 -3.44 -2.84 -5.8 -6.2 -5.8 s-6 2.32 -6 5.8 l0 0.08 c0 3.44 2.68 5.8 6 5.8 z M106.44 27.96 l10.84 0 c-0.32 -3.12 -2.16 -5.56 -5.36 -5.56 c-2.96 0 -5.04 2.28 -5.48 5.56 z M120.08000000000001 37.68 c-1.92 1.72 -4.32 2.8 -7.6 2.8 c-6.12 0 -10.84 -4.44 -10.84 -10.96 l0 -0.08 c0 -6.04 4.28 -11 10.32 -11 c6.72 0 10.04 5.52 10.04 10.4 c0 1.36 -1.04 2.32 -2.28 2.32 l-13.24 0 c0.52 3.44 2.96 5.36 6.08 5.36 c2.04 0 3.64 -0.72 5 -1.84 c0.36 -0.28 0.68 -0.44 1.24 -0.44 c1.08 0 1.92 0.84 1.92 1.96 c0 0.6 -0.28 1.12 -0.64 1.48 z M134.04 40.36 c-3.56 0 -6.08 -1.56 -6.08 -6.2 l0 -11.12 l-0.8 0 c-1.16 0 -2.08 -0.92 -2.08 -2.08 s0.92 -2.08 2.08 -2.08 l0.8 0 l0 -3.6 c0 -1.32 1.08 -2.4 2.44 -2.4 c1.32 0 2.4 1.08 2.4 2.4 l0 3.6 l3.8 0 c1.16 0 2.12 0.92 2.12 2.08 s-0.96 2.08 -2.12 2.08 l-3.8 0 l0 10.36 c0 1.88 0.96 2.64 2.6 2.64 c0.56 0 1.04 -0.12 1.2 -0.12 c1.08 0 2.04 0.88 2.04 2 c0 0.88 -0.6 1.6 -1.28 1.88 c-1.04 0.36 -2.04 0.56 -3.32 0.56 z M153.44000000000003 40.48 c-6.44 0 -11.2 -4.92 -11.2 -10.92 l0 -0.08 c0 -6.04 4.8 -11.04 11.28 -11.04 s11.24 4.92 11.24 10.96 l0 0.08 c0 6 -4.8 11 -11.32 11 z M153.52 36.24 c3.92 0 6.4 -3.04 6.4 -6.68 l0 -0.08 c0 -3.72 -2.68 -6.8 -6.48 -6.8 c-3.88 0 -6.36 3.04 -6.36 6.72 l0 0.08 c0 3.68 2.68 6.76 6.44 6.76 z M179.44000000000003 40.48 c-6.28 0 -10.92 -4.92 -10.92 -10.92 l0 -0.08 c0 -6 4.64 -11.04 11 -11.04 c3.32 0 5.6 1.08 7.4 2.64 c0.32 0.28 0.76 0.88 0.76 1.68 c0 1.24 -1 2.2 -2.24 2.2 c-0.6 0 -1.12 -0.24 -1.44 -0.48 c-1.24 -1.04 -2.6 -1.8 -4.52 -1.8 c-3.52 0 -6.12 3.04 -6.12 6.72 l0 0.08 c0 3.76 2.6 6.76 6.32 6.76 c1.92 0 3.4 -0.76 4.72 -1.88 c0.28 -0.24 0.76 -0.52 1.32 -0.52 c1.16 0 2.08 0.96 2.08 2.12 c0 0.64 -0.24 1.16 -0.68 1.52 c-1.88 1.8 -4.16 3 -7.68 3 z M198.60000000000002 40.44 c-3.96 0 -7.48 -2.28 -7.48 -6.52 l0 -0.08 c0 -4.56 3.56 -6.8 8.72 -6.8 c2.36 0 4.04 0.36 5.68 0.88 l0 -0.52 c0 -3 -1.84 -4.6 -5.24 -4.6 c-1.84 0 -3.36 0.32 -4.68 0.84 c-0.28 0.08 -0.52 0.12 -0.76 0.12 c-1.12 0 -2.04 -0.88 -2.04 -2 c0 -0.88 0.6 -1.64 1.32 -1.92 c2 -0.76 4.04 -1.24 6.8 -1.24 c3.16 0 5.52 0.84 7 2.36 c1.56 1.52 2.28 3.76 2.28 6.52 l0 10.4 c0 1.32 -1.04 2.32 -2.36 2.32 c-1.4 0 -2.36 -0.96 -2.36 -2.04 l0 -0.8 c-1.44 1.72 -3.64 3.08 -6.88 3.08 z M199.96 36.92 c3.2 0 5.64 -1.84 5.64 -4.52 l0 -1.44 c-1.24 -0.48 -2.88 -0.84 -4.8 -0.84 c-3.12 0 -4.96 1.32 -4.96 3.52 l0 0.08 c0 2.04 1.8 3.2 4.12 3.2 z M216 44.2 l0 -23.12 c0 -1.36 1.04 -2.44 2.4 -2.44 s2.44 1.08 2.44 2.44 l0 1.32 c1.56 -2.2 3.76 -3.96 7.2 -3.96 c4.96 0 9.8 3.92 9.8 10.96 l0 0.08 c0 7 -4.8 10.96 -9.8 10.96 c-3.52 0 -5.72 -1.76 -7.2 -3.72 l0 7.48 c0 1.36 -1.08 2.4 -2.44 2.4 c-1.32 0 -2.4 -1.04 -2.4 -2.4 z M226.88 36.24 c3.32 0 6.04 -2.6 6.04 -6.76 l0 -0.08 c0 -4.08 -2.76 -6.76 -6.04 -6.76 s-6.16 2.72 -6.16 6.76 l0 0.08 c0 4.04 2.88 6.76 6.16 6.76 z M249.92000000000002 40.36 c-3.56 0 -6.08 -1.56 -6.08 -6.2 l0 -11.12 l-0.8 0 c-1.16 0 -2.08 -0.92 -2.08 -2.08 s0.92 -2.08 2.08 -2.08 l0.8 0 l0 -3.6 c0 -1.32 1.08 -2.4 2.44 -2.4 c1.32 0 2.4 1.08 2.4 2.4 l0 3.6 l3.8 0 c1.16 0 2.12 0.92 2.12 2.08 s-0.96 2.08 -2.12 2.08 l-3.8 0 l0 10.36 c0 1.88 0.96 2.64 2.6 2.64 c0.56 0 1.04 -0.12 1.2 -0.12 c1.08 0 2.04 0.88 2.04 2 c0 0.88 -0.6 1.6 -1.28 1.88 c-1.04 0.36 -2.04 0.56 -3.32 0.56 z M259.2 13.440000000000001 l0 -0.24 c0 -1.44 1.2 -2.36 2.76 -2.36 s2.76 0.92 2.76 2.36 l0 0.24 c0 1.44 -1.2 2.4 -2.76 2.4 s-2.76 -0.96 -2.76 -2.4 z M259.56 37.8 l0 -16.72 c0 -1.36 1.04 -2.44 2.4 -2.44 s2.44 1.08 2.44 2.44 l0 16.72 c0 1.36 -1.08 2.4 -2.44 2.4 c-1.32 0 -2.4 -1.04 -2.4 -2.4 z M280.76 40.48 c-6.44 0 -11.2 -4.92 -11.2 -10.92 l0 -0.08 c0 -6.04 4.8 -11.04 11.28 -11.04 s11.24 4.92 11.24 10.96 l0 0.08 c0 6 -4.8 11 -11.32 11 z M280.84000000000003 36.24 c3.92 0 6.4 -3.04 6.4 -6.68 l0 -0.08 c0 -3.72 -2.68 -6.8 -6.48 -6.8 c-3.88 0 -6.36 3.04 -6.36 6.72 l0 0.08 c0 3.68 2.68 6.76 6.44 6.76 z M297.00000000000006 37.8 l0 -16.72 c0 -1.36 1.04 -2.44 2.4 -2.44 s2.44 1.08 2.44 2.44 l0 1.04 c1.36 -1.96 3.32 -3.68 6.6 -3.68 c4.76 0 7.52 3.2 7.52 8.08 l0 11.28 c0 1.36 -1.04 2.4 -2.4 2.4 s-2.44 -1.04 -2.44 -2.4 l0 -9.8 c0 -3.28 -1.64 -5.16 -4.52 -5.16 c-2.8 0 -4.76 1.96 -4.76 5.24 l0 9.72 c0 1.36 -1.08 2.4 -2.44 2.4 c-1.32 0 -2.4 -1.04 -2.4 -2.4 z M321.32000000000005 37.04 c0 -1.56 1.2 -2.76 2.84 -2.76 c1.6 0 2.8 1.2 2.8 2.76 l0 0.4 c0 1.56 -1.2 2.76 -2.8 2.76 c-1.64 0 -2.84 -1.2 -2.84 -2.76 l0 -0.4 z M338.64000000000004 40.44 c-3.96 0 -7.48 -2.28 -7.48 -6.52 l0 -0.08 c0 -4.56 3.56 -6.8 8.72 -6.8 c2.36 0 4.04 0.36 5.68 0.88 l0 -0.52 c0 -3 -1.84 -4.6 -5.24 -4.6 c-1.84 0 -3.36 0.32 -4.68 0.84 c-0.28 0.08 -0.52 0.12 -0.76 0.12 c-1.12 0 -2.04 -0.88 -2.04 -2 c0 -0.88 0.6 -1.64 1.32 -1.92 c2 -0.76 4.04 -1.24 6.8 -1.24 c3.16 0 5.52 0.84 7 2.36 c1.56 1.52 2.28 3.76 2.28 6.52 l0 10.4 c0 1.32 -1.04 2.32 -2.36 2.32 c-1.4 0 -2.36 -0.96 -2.36 -2.04 l0 -0.8 c-1.44 1.72 -3.64 3.08 -6.88 3.08 z M340.00000000000006 36.92 c3.2 0 5.64 -1.84 5.64 -4.52 l0 -1.44 c-1.24 -0.48 -2.88 -0.84 -4.8 -0.84 c-3.12 0 -4.96 1.32 -4.96 3.52 l0 0.08 c0 2.04 1.8 3.2 4.12 3.2 z M355.96000000000004 13.440000000000001 l0 -0.24 c0 -1.44 1.2 -2.36 2.76 -2.36 s2.76 0.92 2.76 2.36 l0 0.24 c0 1.44 -1.2 2.4 -2.76 2.4 s-2.76 -0.96 -2.76 -2.4 z M356.32000000000005 37.8 l0 -16.72 c0 -1.36 1.04 -2.44 2.4 -2.44 s2.44 1.08 2.44 2.44 l0 16.72 c0 1.36 -1.08 2.4 -2.44 2.4 c-1.32 0 -2.4 -1.04 -2.4 -2.4 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagetocaptionai);
export default __webpack_public_path__ + "static/media/imagetocaptionai.8536655e663377e5e522ac652f2ea19f.svg";
export { ForwardRef as ReactComponent };